import script from "./CustomTable.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomTable.vue?vue&type=script&setup=true&lang=js"

import "./CustomTable.vue?vue&type=style&index=0&id=586d5a65&lang=scss"

const __exports__ = script;

export default __exports__